"use client";

import { ColumnDef } from "@tanstack/react-table";

import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";

import { DataTableColumnHeader } from "../../../components/shared/data-table/data-table-column-header";

export const columns: any[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Id" />
    ),
    cell: ({ row }) => <div className="max-w-[10px]">{row.getValue("id")}</div>,
    enableSorting: false,
    enableHiding: true,
    size: 10,
    maxSize: 10,
  },
  {
    accessorKey: "name",
    id: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    enableSorting: false,
    enableHiding: true,
    minSize: 100,
    size: 800,
    cell: ({ row }) => {
      const code = row.original.code;
      return (
        <div className="flex flex-col space-y-1">
          <span className="max-w-[500px] truncate font-medium">
            {row.getValue("name")}
          </span>
          {code && (
            <span className="max-w-[500px] truncate text-sm text-muted-foreground">
              {code}
            </span>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "componentCount",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Components" />
    ),
    enableSorting: true,
    enableHiding: true,
    cell: ({ row }) => {
      const count = row.getValue("componentCount");
      return (
        <Badge variant="secondary" className="text-xs">
          {count} component{count !== 1 ? "s" : ""}
        </Badge>
      );
    },
  },
  {
    accessorKey: "use_fabric_prices_for_components",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Use Fabric Prices" />
    ),
    enableSorting: true,
    enableHiding: true,
    cell: ({ row }) => {
      const useFabricPrices = row.getValue("use_fabric_prices_for_components");
      return (
        <Badge
          variant={useFabricPrices ? "default" : "secondary"}
          className="text-xs"
        >
          {useFabricPrices ? "Yes" : "No"}
        </Badge>
      );
    },
  },
  {
    accessorKey: "enable_custom_dimensions_for_components",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Custom Dimensions" />
    ),
    enableSorting: true,
    enableHiding: true,
    cell: ({ row }) => {
      const enableCustomDimensions = row.getValue(
        "enable_custom_dimensions_for_components"
      );
      return (
        <Badge
          variant={enableCustomDimensions ? "default" : "secondary"}
          className="text-xs"
        >
          {enableCustomDimensions ? "Yes" : "No"}
        </Badge>
      );
    },
  },
];
